import { channelClient, RequestPolicies } from 'shared/channels';
import { createEntityClient, runQueuedMutation } from 'shared/channels/entity';
import { DomainMessagesTypes } from 'shared/domain/messages/message';
import type { UserInDto } from './types/inDto';
import type { UserCreateModel, UserDeleteModel, UserEditModel, UserModel } from './types/model';
import { userContract } from './userContract';

/**
 * Users of the selected project as served by the service worker. Changes
 * resolve once the server accepted them and reject with its error
 * (`ChannelRequestError.messageId`).
 */
export const userClient = {
  ...createEntityClient(userContract),

  /** One user for its details view; rejects when there is none. */
  getOneById(id: string): Promise<UserModel> {
    return channelClient.request(userContract, 'getOneById', { id }, RequestPolicies.read);
  },

  /** Resolves with the user the server created. */
  create(userCreateModel: UserCreateModel): Promise<UserInDto> {
    return runQueuedMutation(
      userContract,
      'create',
      (uniqueId) => ({ userCreateModel, uniqueId }),
      DomainMessagesTypes.uploadedEntity
    );
  },

  async edit(userEditModel: UserEditModel): Promise<void> {
    await runQueuedMutation(
      userContract,
      'edit',
      (uniqueId) => ({ userEditModel, uniqueId }),
      DomainMessagesTypes.updatedEntity
    );
  },

  async remove(userDeleteModel: UserDeleteModel): Promise<void> {
    await runQueuedMutation(
      userContract,
      'remove',
      (uniqueId) => ({ userDeleteModel, uniqueId }),
      DomainMessagesTypes.deletedEntity
    );
  },
};
